const packagesDesignEditor = {
}

const packagesContentEditor = {
  customTemplate: `<div class="ae-package ae-package-default" :class="package.css_classes">
  <Truncate class="ae-package-default-title" :value="package.name" />
  <span class="ae-package-default-subtitle" v-html="package.tagline"></span>

  <!--template v-if="!hasRecurrency">
      <div class="ae-package-default-price-per-credit-with-discount">
          <template v-if="hasCreditBonus || hasDiscount">
              <span>de</span>
              <span class="ae-package-default-price-per-credit-with-discount-value">{{ $n(priceDividedPerCredit,
                  'currency') }}</span>
              <span>por</span>
          </template>
      </div-->

  <!--div class="ae-package-default-price-per-credit">
          <span class="ae-package-default-price-per-credit-currency">{{ currencySymbol }}</span>
          <span class="ae-package-default-price-per-credit-value">{{
              getValueWithoutSymbol(currentPriceDividedPerCredit) }}</span>
          <template v-if="!isUnlimited">
              <span class="ae-package-default-price-per-credit-unit">/ aula</span>
          </template>
      </div-->

  <div class="ae-package-default-price">
      <template v-if="hasDiscount">
          <span>DE</span>
          <span class="ae-package-default-price-with-discount">{{ $n(this.package.price_sales_base, 'currency')
              }}</span>
          <span>POR</span>
          <b>{{ $n(this.package.current_price, 'currency') }}</b>
      </template>
      <template v-else>
          <span>POR</span>
          <b>{{ $n(this.package.current_price, 'currency') }}</b>
      </template>

      <!--template v-if="hasManyInstallments">
              <div class="ae-package-default-installments">em até {{ greaterInstallmentDesc }}</div>
          </template>
          <template v-else>
              <div class="ae-package-default-without-installments">à vista</div>
          </template>
      </div>
  </template-->

      <template v-else>
          <div class="ae-package-default-recurrency-price-with-discount">
              <template v-if="hasDiscount">
                  <span>De</span>
                  


                  <span class="ae-package-default-price-per-credit-with-discount-value">{{
                      $n(package.price_sales_base,
                      'currency') }}</span>
                  <span>por</span>
                  
              </template>
          </div>

          <div class="ae-package-default-recurrency-price">
              <span class="ae-package-default-recurrency-price-currency">{{ currencySymbol }}</span>
              <span class="ae-package-default-recurrency-price-value">{{ getValueWithoutSymbol(package.current_price)
                  }}</span>
          </div>

          <div class="ae-package-default-recurrency-price-info">
          <template v-if="config.showUnlimitedExplanation">
              <div>Até {{ $n(currentPriceDividedPerCredit, 'currency') }} / aula</div>
              <template v-if="package.current_event_credit_quantity > 1">
                  <div>Se fizer {{package.current_event_credit_quantity }} aulas no mês</div>
              </template>
              <template v-else>
                  <div>Se fizer {{package.current_event_credit_quantity }} aula no mês</div>
              </template>
          </template>
      </div>
  </template>

          <button class="btn btn-primary buy-pack ae-package-default-action-btn my-1" @click="addToCheckout">ADQUIRA
              AGORA ESSA OFERTA</button>

          <!--div class="ae-package-default-credit-info">
      <div class="ae-package-default-credit-info-item">
          <p>
              <span class="tabela-esquerda">CRÉDITOS</span>
              <template v-if="!isUnlimited">
                  <span class="tabela-direita">{{ package.event_credit_quantity }}</span>
              </template>
              <template v-else>
                  <span class="tabela-direita">ILIMITADO</span>
              </template>
          </p>
      </div-->

          <!--div class="ae-package-default-divider"></div-->

          <!--div class="ae-package-default-validity">
          <p>
              <span class="tabela-esquerda">VALIDADE</span>
              <template v-if="package.current_event_credit_validity > 1">
                  <span class="tabela-direita">{{ package.current_event_credit_validity }} DIAS</span>
              </template>
              <template v-else>
                  <span class="tabela-direita">{{package.current_event_credit_validity}} DIA</span>
              </template>
          </p>
      </div-->

          <!--div class="ae-package-default-divider"></div-->

          <div class="ae-package-default-credit-info-item ae-package-default-credit-info-item-right">
              <template v-if="hasCreditBonus">
                  <span>+{{ creditBonus }} bônus</span>
              </template>
              <template v-else>
                  <p>
                      <template v-if="package.current_are_credits_transferable">
                          <span class="tabela-esquerda">CRÉDITOS TRANSFERÍVEIS</span>
                      </template>
                      <template v-else>
                          <span class="tabela-direita"></span>
                      </template>
                  </p>
              </template>
          </div>
  </div>

  <template v-if="hasCreditBonus">
      <div class="ae-package-default-transferable">
          <p>
              <template v-if="package.current_are_credits_transferable">
                  <span class="tabela-esquerda">CRÉDITOS TRANSFERÍVEIS</span>
              </template>
              <template v-else>
                  <span class="tabela-direita"></span>
              </template>
          </p>
      </div>
  </template>

  <!--div class="buy">{{
  $n(package.price_sales_base, 'currency') }}
</div-->
</div>`,
  useCustomTemplate: false,
  separationMode: '', // '' section button
  categorySlugList: [],
  showFloatingCart: 'always', // never always,
  useAddToCartButton: false,
  useBuyButton: true,
  exibitionCredityQuantity:'total-detail',
  packageUnlimitedInvertValue:true,
  // showUnlimitedExplanation: false,
  // addToCartButtonText: '',
  // removeFromCartButtonText: '',
  // buyButtonText: '',
  useDefaultGridCols: true,
  usePOSAsFilter: false,
  packageParams: JSON.stringify({
    teste: 1
  }),
  show_in_carroussel_mobile: false,
  show_in_carroussel_desktop: false,
  //titleWidget:'Pacotes', 
  use_location_unit_selector: false,
  
//   location_unit_selector_params: JSON.stringify({
//       "activity_list": "3"
//   }),
  bonusStripColor: 'red',
  showinstallmentsLabel: true,
  showIconsWithInformation:true,
  //use_multi_widgets: true,
  //multi_widgets_params: JSON.stringify([{"recurrency_enabled":"true", "title": "Recorrentes"}, {"recurrency_enabled":"false", "title": "Pacotes"}]),
  //paramsFilterRequestPOS:JSON.stringify({"tag":"grom"}),

  paramsFilterRequestLocationsSelect:JSON.stringify({}),
  //paramsFilterRequestPOSSelect:JSON.stringify({"tag":"arenabtg"}),

  useCookieSetPOS:true,

  componentOld:false,

  // disableGetPackagesOnRender: true
}

export {
  packagesDesignEditor,
  packagesContentEditor,
}